<section class="tag_group_line" [ngClass]="isDown ? cssClassForCollapse : 'is-up'">
  <div class="tag_group_line_item" (click)="onClickGroup($event)">
    <span class="chevron" [ngClass]="isDown ? cssClassForCollapseIcon : 'icon-chevron-up'"></span>
    <span class="tag_group_line_item_name">
      {{ group.name === "boolean" ? '' : group.name }} ({{ group.total }})
    </span>
    <span class="chevron" [ngClass]="isDown ? cssClassForCollapseIcon : 'icon-chevron-up'"></span>
  </div>
  @if (tagsList?.list.length > 0) {
    <div class="tag_group_line_list">
      <ul>
        @for (tag of tagsList.list; track tag) {
          <li>
            @if (isDown === false) {
              <app-tag [tag]=tag [tableColumns]="tableColumns" [columnsToNotDisplay]="columnsToNotDisplay" (eventOnClick)="onEventOnClick($event)"></app-tag>
            }
          </li>
        }
      </ul>
      @if (tagsList.paging.nextItemsLink && isDown === false) {
        <div class="show-more" (click)="showMore()">
          <span class="icon-arrow-down-circle show-more-icon"></span>
          <span class="tag_group_line_item_name">{{'action.show_more_lines' | translate}}</span>
          <span class="icon-arrow-down-circle show-more-icon"></span>
        </div>
      }
    </div>
  }
  <div>
    <!-- suivant -->
  </div>
</section>
